import { render, staticRenderFns } from "./DropdownMetricFields.vue?vue&type=template&id=785ca012&scoped=true&"
import script from "./DropdownMetricFields.vue?vue&type=script&lang=js&"
export * from "./DropdownMetricFields.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMetricFields.vue?vue&type=style&index=0&id=785ca012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ca012",
  null
  
)

export default component.exports